import React from 'react';

import { Link, browserHistory } from 'react-router';
import $ from 'jquery';

import {
	Tab,
	Row,
	Col,
	// Nav,
	// NavItem,
	Glyphicon,
	// Tooltip,
	// OverlayTrigger
	FormGroup,
	// ControlLabel,
	FormControl,
	// HelpBlock,
	// InputGroup,
	// Form,
	// Checkbox,
	// Radio
} from 'react-bootstrap';

import { DataListWrapper, emptyDataList } from '../../../commonComponents/DataTable/DataTablePs';
import Tooltip from '../../../commonComponents/Tooltip';
import getRoute from '../../../commonJS/getRoute';
import searchContent from '../../../commonJS/searchContent';
import getFuncTabRoute from '../../../commonJS/getFuncTabRoute';
import parentStateHandler from '../../../commonJS/parentStateHandler';
import getAdminItemStateName from '../newAdmin/getAdminItemStateName';
import adminRouteList from '../newAdmin/adminRouteList';
import BatchUploadModalCt from './BatchUploadModalCt';


// 驗證點擊是否連容器的click事件一同觸發
export const AddTrigger = props => (
	<Tooltip
		tipText={props.disabled ? '您沒有新增權限' : '建立新項目'}
		// placement='top'
		onClick={props.disabled ? null : props.onClick}
		child={
			<span style={props.disabled ? { cursor: 'initial' } : null}
				className={(props.className || '') + 'span-add-item-icon'}></span>
		}
	/>
);

export const BatchUITrigger = props => (
	<Tooltip
		// placement='top'
		tipText={props.tipText}
		onClick={props.onClick}
		child={<span className={props.className || 'span-batch-upload-icon'}></span>}
	/>
);


export default class SideBarGroupCt extends React.Component {
	constructor(props) {
		super(props);

		this.getRoute = (backNum, child) => {
			return getRoute(this.props.routes, backNum, child);
		};

		this.handlers = {
			onBatchBtnClick: (stateName) => {
				return (e) => {
					e.stopPropagation();
					this.setState({ [stateName]: !this.state[stateName] });
				};
			},
			clickAdd: e => {
				e.preventDefault();
				e.stopPropagation();
				this.props.routeHandler(this.getRoute(0, 'create'));
			},
			closeModal: (optsObj) => {
				let cbToRun = '', isDeletion = false;
				if (optsObj) {
					cbToRun = optsObj.cbToRun;
					isDeletion = optsObj.isDeletion;
				}

				// this.setState({showModal: false});
				// showModal固定為true，改由路由控制是否展示，
				// 因為按上一步時控制狀態的元件不會重置，
				// 若showModal當時的狀態是false就會變成路由和狀態不符
				if (cbToRun) cbToRun();
				else this.props.routeHandler(this.getRoute(1), isDeletion ? 'replace' : '');
				// 刪除後路由應被覆蓋
			},
			onLocalSearchToggle: () => {
				this.setState({ showLocalSearchForm: !this.state.showLocalSearchForm });
			},
			onCloudSearchToggle: () => {
				this.setState({ showCloudSearchForm: !this.state.showCloudSearchForm });
			},
			updateSearchResults: () => {
				if (this.state.searchTextInputValue) this.handlers.onSearchChange();
			},
			onSearchChange: e => {
				const searchStr = e ? e.target.value : this.state.searchTextInputValue;
				let searchResults = {};

				function filter(dataObjArr, keysToSearch, idKeyName) {
					const filteredData = searchContent([searchStr], dataObjArr, keysToSearch),
						len = filteredData.length;

					let indexMap = [];
					for (let i = 0; i < len; i++) {
						indexMap.push(i);
					}

					searchResults = new DataListWrapper(indexMap, filteredData, idKeyName || '');
				}

				if (searchStr) {
					switch (getFuncTabRoute(this.getRoute(0))) {
						case 'news':
							filter(this.props.filteredDataList._data, ['title', 'flag', 'type_name', 'start_time', 'end_time', 'message']);
							break;
						case 'work-log':
							filter(this.props.workLogProps.workLogSortedData._data, ['reg_time', 'work_group_name', 'work_owner_name', 'company_name', 'contact_name', 'visit_start_date', 'nature_name', 'content', 'worklog_discuss_count']);
							break;
						case 'product':
							filter(this.props.propsFromSaleSky.productProps.productSortedData._data, ['name']);
							break;
						case 'km':
							filter(this.props.propsFromSaleSky.kmProps.productSortedData._data, ['name']);
							break;
						case 'customer':
							filter(this.props.filteredDataList._data, ['name', 'president', 'telephone', 'industry_name', 'address', 'tax_number', 'notes']);
							break;
						case 'shipping-records':
							filter(this.state.shippingRecordsSortedData._data, [
								'delivery_number', 'order_number', 'delivery_date', 'company_name',
								'contact_name', 'address', 'tel', 'fax', 'model_name', 'serial_number',
								'arrival_date', 'install_date', 'amount', 'warranty_date', 'bom_number', 'notes'
							], 'company_id');
							break;
						case 'sales-cases':
							filter(this.state.salesCasesSortedData._data, [
								'case_createdate', 'company_name', 'case_owner_name', 'case_quoteday', 'case_validly', 'case_remark'
							], 'company_id');
							break;
						case 'parts-base':
							filter(this.state.partsBaseSortedData._data, ['part_id', 'part_name', 'part_spec', 'supplier_name', 'storage_capacity', 'units', 'unit_price', 'currency']);
							break;
						case 'form-quotation':
							filter(this.state.formQuotationSortedData._data, ['customer_name']);
							break;
						case 'form-cost':
							filter(this.state.formCostSortedData._data, ['customer_name']);
							break;
						case 'form-margin':
							filter(this.state.formMarginSortedData._data, ['customer_name']);
							break;
						case 'form-order':
							filter(this.state.formOrderSortedData._data, ['customer_name']);
							break;
						case 'form-goods':
							filter(this.state.formGoodsSortedData._data, ['customer_name']);
							break;
						case 'form-lading':
							filter(this.state.formLadingSortedData._data, ['customer_name']);
							break;
						case 'form-invoice':
							filter(this.state.formInvoiceSortedData._data, ['customer_name']);
							break;
						case 'form-warehouse':
							filter(this.state.formWarehouseSortedData._data, ['customer_name']);
							break;
						case 'new-admin':
							const adminItemRoute = getFuncTabRoute(this.props.pathname, adminRouteList);
							if (adminItemRoute === -1) break;
							const dataWrapperStateName = getAdminItemStateName(adminItemRoute).dataWrapperStateName;

							switch (adminItemRoute) {
								case 'user-account':
									filter(this.state[dataWrapperStateName]._data, ['emp_id', 'user_name', 'email', 'user_account', 'group_name', 'role_name']);
									break;
								case 'user-role':
									filter(this.state[dataWrapperStateName]._data, ['main_role', 'role_name', 'department_id']);
									break;
								case 'user-group':
									filter(this.state[dataWrapperStateName]._data, ['name', 'color_code']);
									break;
								case 'supervisor-evaluation':
									filter(this.state[dataWrapperStateName]._data, ['name', 'remark']);
									break;
								case 'repair-area':
									filter(this.state[dataWrapperStateName]._data, ['area_type_name']);
									break;
								case 'repair-status':
									filter(this.state[dataWrapperStateName]._data, ['status_name', 'color_code']);
									break;
								case 'repair-form-type':
									filter(this.state[dataWrapperStateName]._data, ['type_name']);
									break;
								case 'repair-warranty-type':
									filter(this.state[dataWrapperStateName]._data, ['warranty_type_name']);
									break;
								case 'repair-product-from':
									filter(this.state[dataWrapperStateName]._data, ['from_name']);
									break;
								case 'repair-service-type':
									filter(this.state[dataWrapperStateName]._data, ['service_type_name']);
									break;
								case 'repair-owner-judgement':
									filter(this.state[dataWrapperStateName]._data, ['judge_name']);
									break;
								case 'repair-currency':
									filter(this.state[dataWrapperStateName]._data, ['currency_name']);
									break;
								case 'repair-service-satisfaction':
									filter(this.state[dataWrapperStateName]._data, ['satisfaction_name']);
									break;
								case 'repair-issue-type':
									filter(this.state[dataWrapperStateName]._data, ['issue_type_name']);
									break;
								case 'system-parameter-setting':
									filter(this.state[dataWrapperStateName]._data, ['item', 'value', 'remark']);
									break;
								case 'company-introduction':
									filter(this.state[dataWrapperStateName]._data, ['company_name', 'title', 'content']);
									break;
								case 'company-zone':
									filter(this.state[dataWrapperStateName]._data, ['name']);
									break;
								case 'company-industry':
									filter(this.state[dataWrapperStateName]._data, ['name']);
									break;
								case 'company-trade':
									filter(this.state[dataWrapperStateName]._data, ['name']);
									break;
								case 'work-nature':
									filter(this.state[dataWrapperStateName]._data, ['name']);
									break;
								case 'work-progress':
									filter(this.state[dataWrapperStateName]._data, ['name']);
									break;
								case 'project-progress':
									filter(this.state[dataWrapperStateName]._data, ['name']);
									break;
								case 'media-cloud-file-attribute':
									filter(this.state[dataWrapperStateName]._data, ['name']);
									break;
								case 'media-cloud-file-attribute-value':
									filter(this.state[dataWrapperStateName]._data, ['fileproperty_id', 'name']);
									break;
								case 'news-type':
									filter(this.state[dataWrapperStateName]._data, ['name']);
									break;
								default:

							};

							break;
						case 'UserGroup':
						case 'Zone':
						case 'Industry':
						case 'Trade':
						case 'WorkNature':
						case 'ProgressStatus':
						case 'ProjectProgress':
						case 'NewsType':
						case 'FileProperty':
							filter(this.props.filteredDataList._data, ['name']);
							break;
						case 'FilePropertyValue':
							filter(this.props.filteredDataList._data, ['name', 'fileproperty_name']);
							break;
						case 'Role':
							filter(this.props.filteredDataList._data, ['main_role_name', 'role_name', 'department_name']);
							break;
						case 'ManageAccount':
							filter(this.props.filteredDataList._data, ['user_name']);
							break;
						case 'online-repair-service':
							filter(this.props.filteredDataList._data, ['company_name', 'repair_id', 'model_name', 'serial_number', 'issue_description', 'create_user', 'warranty_type_name', 'fix_user_name', 'area_type_name', 'request_date']);
							break;

						default:
					}
				}

				this.setState({ searchTextInputValue: searchStr, searchResults });
			},
			onSearchTextClear: () => {
				if (this.state.showLocalSearchForm) {
					this.setState({ showLocalSearchForm: false, searchTextInputValue: '', searchResults: {} });
				}
			},
			onLinkClick: funcTabRoute => {
				const { languageData, languageCode } = window.myConsts;

				let onTabName = '';
				switch (funcTabRoute) {
					case 'news':
						onTabName = languageData['42'][languageCode];
						break;
					case 'calendar':
						onTabName = languageData['54'][languageCode];
						break;
					case 'work-log':
						onTabName = languageData['80'][languageCode];
						break;
					case 'customer':
						onTabName = languageData['73'][languageCode];
						break;
					case 'sales-cases':
						onTabName = languageData['479'][languageCode];
						break;
					case 'shipping-records':
						onTabName = languageData['436'][languageCode];
						break;
					case 'product':
						onTabName = languageData['72'][languageCode];
						break;
					case 'km':
						onTabName = languageData['270'][languageCode];
						break;
					case 'online-repair-service':
						onTabName = languageData['5006'] ? languageData['5006'][languageCode] : languageData['448'][languageCode];
						break;
					case 'parts-base':
						onTabName = languageData['413'][languageCode];
						break;
					case 'media-cloud':
						onTabName = languageData['65'][languageCode];
						break;
					case 'report':
						onTabName = languageData['75'][languageCode];
						break;
					case 'form-quotation':
						onTabName = languageData['5007'] ? languageData['5007'][languageCode] : languageData['448'][languageCode];
						break;
					case 'form-cost':
						onTabName = languageData['5008'] ? languageData['5008'][languageCode] : languageData['448'][languageCode];
						break;
					case 'form-margin':
						onTabName = languageData['5009'] ? languageData['5009'][languageCode] : languageData['448'][languageCode];
						break;
					case 'form-order':
						onTabName = languageData['5010'] ? languageData['5010'][languageCode] : languageData['448'][languageCode];
						break;
					case 'form-goods':
						onTabName = languageData['5011'] ? languageData['5011'][languageCode] : languageData['448'][languageCode];
						break;
					case 'form-lading':
						onTabName = languageData['5012'] ? languageData['5012'][languageCode] : languageData['448'][languageCode];
						break;
					case 'form-invoice':
						onTabName = languageData['5013'] ? languageData['5013'][languageCode] : languageData['448'][languageCode];
						break;
					case 'form-warehouse':
						onTabName = languageData['5014'] ? languageData['5014'][languageCode] : languageData['448'][languageCode];
						break;
					case 'new-admin':
						onTabName = languageData['460'][languageCode];
						break;
					case 'UserCompanyInfo':
						onTabName = '公司簡介';
						break;
					case 'Role':
						onTabName = '角色';
						break;
					case 'Zone':
						onTabName = '地區';
						break;
					case 'Industry':
						onTabName = '行業別';
						break;
					case 'Trade':
						onTabName = '產業';
						break;
					case 'WorkNature':
						onTabName = '工作性質';
						break;
					case 'ProgressStatus':
						onTabName = '工作進度';
						break;
					case 'ProjectProgress':
						onTabName = '專案狀態';
						break;
					case 'NewsType':
						onTabName = '新聞分類';
						break;
					case 'FilePropertyValue':
						onTabName = '檔案屬性值';
						break;
					case 'FileProperty':
						onTabName = '檔案屬性';
						break;
					case 'ManageAccount':
						onTabName = '帳戶管理';
						break;
					case 'UserGroup':
						onTabName = '使用者群組';
						break;
					default:
				}

				return { funcTabRoute, onTabName };
			},
			onWindowHeightChange: () => {
				if (!this.state.overHeating) {
					this.setState({ overHeating: true });

					this.timerId = setTimeout(() => {
						let { tableHeight } = this.setHeight();
						this.setState({
							tableHeight,
							overHeating: false
						});
					}, 1000);
				}
			}
		};

		this.setHeight = () => {
			const jqObj = $('#div-sidebar-container-pane-third');

			jqObj.css('height', '100vh');

			let tabHeight = parseFloat(jqObj.css('height')) - 80,
				tableHeight = tabHeight - 61 - 20;

			if (tabHeight < 558) tabHeight = 558;
			jqObj.css('height', tabHeight);


			if (tableHeight < 477) tableHeight = 477;
			return { tableHeight };
		};

		this.timerId = '';
		this.routeUnListener = '';
		// userPermission 有3個地方會用到，permissionVerifier.js、LoggedInChecker、這裡
		// 過程中不會變，以一個物件記錄即可，不必設為state
		this.permissions = {
			// 最新消息 
			news: this.props.userPermission.salesky_news_web === '3',
			// 產品資訊
			product: this.props.userPermission.salesky_product_web === '3' ||
				this.props.userPermission.salesky_products_web === '3',
			// 服務單
			onlineRepair:
				location.hostname === 'localhost' ||
				this.props.userPermission.salesky_repair_web * 1 > 1 ||
				this.props.userPermission.servicesky_repair_web * 1 > 1,
			// 估價單
			formQuotation: this.props.userPermission.salesky_quotation_web === '3',
			// 成本分析表
			formCost: this.props.userPermission.salesky_cost_web === '3',
			// 保證金申請單
			formMargin: this.props.userPermission.salesky_margin_web === '3',
			// 訂單
			formOrder: this.props.userPermission.salesky_order_web === '3',
			// 貨品申購書
			formGoods: this.props.userPermission.salesky_goods_web === '3',
			// 領貨單
			formLading: this.props.userPermission.salesky_lading_web === '3',
			// 發票申請單
			formInvoice: this.props.userPermission.salesky_invoice_web === '3',
			// 入庫單
			formWarehouse: this.props.userPermission.salesky_warehouse_web === '3',
			// 該專案用不到的權限
			calendar: this.props.userPermission.salesky_calendar_web === '3',
			workLog: this.props.userPermission.salesky_worklog_web === '3',
			customer: this.props.userPermission.salesky_customers_web === '3',
			saleCase: this.props.userPermission.salesky_sales_case_web === '3',
			shippingRecords: this.props.userPermission.servicesky_delivery_order_web === '3',
			km: this.props.userPermission.servicesky_km_web === '3',
			partsBase: this.props.userPermission.servicesky_part_web === '3',
			mediaCloud: this.props.userPermission.salesky_media_cloud_web === '3',
			report: this.props.userPermission.salesky_report_web === '3'
		};

		this.state = {
			overHeating: false,
			showLocalSearchForm: false,
			searchTextInputValue: '',
			showCloudSearchForm: false,
			searchTextValue: '',
			searchResults: {},
			tableHeight: 0,
			// 預設選定功能
			funcTabRoute: 'news',
			onTabName: '訊息發佈',
			// 批次上傳
			showBatchUploadModal: false,
			// 批次匯出PDF
			showBatchExportUI: false,
			// hoist至最近的parent即可，salesky太上層
			partsBaseSortedData: {},
			partsBaseColSortDirs: {},
			// ShippingRecords
			shippingRecordsSortedData: {},
			shippingRecordsColSortDirs: {},
			// ShippingRecords on customer tab
			shippingRecordsSortedData_cus: {},
			shippingRecordsColSortDirs_cus: {},
			// SalesCases
			salesCasesSortedData: {},
			salesCasesColSortDirs: {},
			// formQuotation
			formQuotationSortedData: {},
			formQuotationColSortDirs: {},
			// formCost
			formCostSortedData: {},
			formCostColSortDirs: {},
			// formMargin
			formMarginSortedData: {},
			formMarginColSortDirs: {},
			// formOrder
			formOrderSortedData: {},
			formOrderColSortDirs: {},
			// formGoods
			formGoodsSortedData: {},
			formGoodsColSortDirs: {},
			// formLading
			formLadingSortedData: {},
			formLadingColSortDirs: {},
			// formInvoice
			formInvoiceSortedData: {},
			formInvoiceColSortDirs: {},
			// formWarehouse
			formWarehouseSortedData: {},
			formWarehouseColSortDirs: {},
			// new-admin ======
			// 以下data預設物件皆需加上shouldFetchData key做為是否需抓取資料判斷用
			// user-account
			userAccountSortedData: { shouldFetchData: true },
			userAccountColSortDirs: {},
			// user-role
			userRoleSortedData: { shouldFetchData: true },
			userRoleColSortDirs: {},
			// user-group
			userGroupSortedData: { shouldFetchData: true },
			userGroupColSortDirs: {},
			// supervisor-evaluation
			supervisorEvaluationSortedData: { shouldFetchData: true },
			supervisorEvaluationColSortDirs: {},
			// repair-area
			repairAreaSortedData: { shouldFetchData: true },
			repairAreaColSortDirs: {},
			repairAreaApiAdaptedData: [],
			// repair-status
			repairStatusSortedData: { shouldFetchData: true },
			repairStatusColSortDirs: {},
			repairStatusApiAdaptedData: [],
			// repair-form-type
			repairFormTypeSortedData: { shouldFetchData: true },
			repairFormTypeColSortDirs: {},
			repairFormTypeApiAdaptedData: [],
			// repair-warranty-type
			repairWarrantyTypeSortedData: { shouldFetchData: true },
			repairWarrantyTypeColSortDirs: {},
			repairWarrantyTypeApiAdaptedData: [],
			// repair-product-from
			repairProductFromSortedData: { shouldFetchData: true },
			repairProductFromColSortDirs: {},
			repairProductFromApiAdaptedData: [],
			// repair-service-type
			repairServiceTypeSortedData: { shouldFetchData: true },
			repairServiceTypeColSortDirs: {},
			repairServiceTypeApiAdaptedData: [],
			// repair-owner-judgement
			repairOwnerJudgementSortedData: { shouldFetchData: true },
			repairOwnerJudgementColSortDirs: {},
			repairOwnerJudgementApiAdaptedData: [],
			// repair-currency
			repairCurrencySortedData: { shouldFetchData: true },
			repairCurrencyColSortDirs: {},
			repairCurrencyApiAdaptedData: [],
			// repair-service-satisfaction
			repairServiceSatisfactionSortedData: { shouldFetchData: true },
			repairServiceSatisfactionColSortDirs: {},
			repairServiceSatisfactionApiAdaptedData: [],
			// repair-issue-type
			repairIssueTypeSortedData: { shouldFetchData: true },
			repairIssueTypeColSortDirs: {},
			repairIssueTypeApiAdaptedData: [],
			// system-parameter-setting
			systemParameterSettingSortedData: { shouldFetchData: true },
			systemParameterSettingColSortDirs: {},
			// company-introduction
			companyIntroductionSortedData: { shouldFetchData: true },
			companyIntroductionColSortDirs: {},
			// company-zone
			companyZoneSortedData: { shouldFetchData: true },
			companyZoneColSortDirs: {},
			// company-industry
			companyIndustrySortedData: { shouldFetchData: true },
			companyIndustryColSortDirs: {},
			// company-trade
			companyTradeSortedData: { shouldFetchData: true },
			companyTradeColSortDirs: {},
			// work-nature
			workNatureSortedData: { shouldFetchData: true },
			workNatureColSortDirs: {},
			// work-progress
			workProgressSortedData: { shouldFetchData: true },
			workProgressColSortDirs: {},
			// project-progress
			projectProgressSortedData: { shouldFetchData: true },
			projectProgressColSortDirs: {},
			// media-cloud-file-attribute
			mediaCloudFileAttributeSortedData: { shouldFetchData: true },
			mediaCloudFileAttributeColSortDirs: {},
			// media-cloud-file-attribute-value
			mediaCloudFileAttributeValueSortedData: { shouldFetchData: true },
			mediaCloudFileAttributeValueColSortDirs: {},
			// news-type
			newsTypeSortedData: { shouldFetchData: true },
			newsTypeColSortDirs: {},
			newsTypeApiAdaptedData: [],
			// =======
			// factories
			contentTableSortedData: { shouldFetchData: true },
			contentTableColSortDirs: {},
			// ===
		};

		this.parentStateHandler = ({ states, newValues, cb }) => {
			parentStateHandler({ states, newValues, parentThis: this, cb });
		};

	}

	componentDidMount() {
		// 將在函數中直接執行的setState動作，
		// 改為回傳包含要更新的state名稱與值的物件，
		// 最後再一起一次使用spread將state物件展開更新，
		// 減少update次數，如下例做法
		const newState1 = this.setHeight(),
			newState2 = this.handlers.onLinkClick(getFuncTabRoute(this.getRoute(0)));
		this.setState({ ...newState1, ...newState2 });

		// listen height change event
		$(window).resize(this.handlers.onWindowHeightChange);

		// listen route change event, will return a func for unmounting handler.
		this.routeUnListener = browserHistory.listenBefore(location => {
			const funcTabRoute = getFuncTabRoute(location.pathname);

			if (funcTabRoute !== this.state.funcTabRoute) {
				let { onTabName } = this.handlers.onLinkClick(funcTabRoute);

				this.setState({
					showLocalSearchForm: false,
					searchTextInputValue: '',
					showCloudSearchForm: false,
					searchResults: {},
					funcTabRoute,
					onTabName
				});
			}

		});
	}

	componentDidUpdate(prevProps, prevStates) {
		// 只在由隱藏轉為顯示的情況才需focus
		if (!prevStates.showLocalSearchForm && this.state.showLocalSearchForm) {
			$('#div-search-form-group > input').focus();
		}
	}

	componentWillUnmount() {
		$(window).off('resize', this.handlers.onWindowHeightChange);
		this.routeUnListener();
		clearTimeout(this.timerId);
	}

	render() {
		const { languageData, languageCode } = window.myConsts;

		const props = this.props, state = this.state;

		let contentTable = '',
			showAddTrigger = !(
				// state.funcTabRoute === 'online-repair-service' ||
				// state.funcTabRoute === 'form-quotation' ||
				state.funcTabRoute === -1 ||
				state.funcTabRoute === 'form-cost' ||
				state.funcTabRoute === 'form-margin' ||
				state.funcTabRoute === 'form-order' ||
				state.funcTabRoute === 'form-goods' ||
				state.funcTabRoute === 'form-lading' ||
				state.funcTabRoute === 'form-invoice' ||
				state.funcTabRoute === 'form-warehouse' ||
				state.funcTabRoute === 'media-cloud' ||
				state.funcTabRoute === 'report' ||
				state.funcTabRoute === 'FileProperty' ||
				state.funcTabRoute === 'UserCompanyInfo'
			),
			showLocalSearchIcon =
				!(
					state.funcTabRoute === -1 ||
					state.funcTabRoute === 'calendar' ||
					state.funcTabRoute === 'media-cloud' ||
					state.funcTabRoute === 'report' ||
					state.funcTabRoute === 'UserCompanyInfo'
				),
			showCloudSearchIcon =
				(
					state.funcTabRoute === 'form-quotation' ||
					state.funcTabRoute === 'online-repair-service'
				),
			// showBatchUploadTrigger = (
			// 	state.funcTabRoute === 'shipping-records'
			// ),
			showBatchExportTrigger =
				(
					state.funcTabRoute === 'form-quotation' ||
					state.funcTabRoute === 'online-repair-service'
				),
			currentFuncTabRoute = getFuncTabRoute(props.pathname);

		if (props.content) {
			let
				// 舊功能新增屬性用
				oldFuncExtraProps,
				requiredProps,
				commonProps = {
					// 資料結構要符合pure component需求
					// content table area 要全部落實scu，避免不必要的re-render
					closeModal: this.handlers.closeModal,
					routeHandler: props.routeHandler,
					tableHeight: state.tableHeight,
					isBigSideBar: props.isBigSideBar,
					updateSearchResults: this.handlers.updateSearchResults,
					searchResults: state.searchResults,
					parentStateHandler: this.parentStateHandler,
					propsPackageFromSkyFamily: props.propsPackageFromSkyFamily,
					tableWidth: props.workLogProps.tableWidth
				};

			switch (currentFuncTabRoute) {
				case 'parts-base':
					requiredProps = {
						partsBaseSortedData: state.partsBaseSortedData,
						partsBaseColSortDirs: state.partsBaseColSortDirs,
						...commonProps
					};
					break;
				case 'sales-cases':
					requiredProps = {
						salesCasesSortedData: state.salesCasesSortedData,
						salesCasesColSortDirs: state.salesCasesColSortDirs,
						productProps: props.propsFromSaleSky.productProps,
						stateHandler: props.stateHandler,
						userId: props.userId,
						userName: props.userName,
						...commonProps
					};
					break;
				case 'shipping-records':
					requiredProps = {
						shippingRecordsSortedData: state.shippingRecordsSortedData,
						shippingRecordsColSortDirs: state.shippingRecordsColSortDirs,
						productProps: props.propsFromSaleSky.productProps,
						stateHandler: props.stateHandler,
						...commonProps
					};
					break;
				case 'form-quotation':
					oldFuncExtraProps = {
						parentStateHandler: this.parentStateHandler,
						loginCompanyInfo: props.propsPackageFromSkyFamily,
						// showBatchExportUI: state.showBatchExportUI,
						showCloudSearchForm: state.showCloudSearchForm,
					};

					requiredProps = {
						formQuotationSortedData: state.formQuotationSortedData,
						formQuotationColSortDirs: state.formQuotationColSortDirs,
						productProps: props.propsFromSaleSky.productProps,
						stateHandler: props.stateHandler,
						userId: props.userId,
						userName: props.userName,
						...commonProps
					};
					break;
				case 'form-cost':
					requiredProps = {
						formCostSortedData: state.formCostSortedData,
						formCostColSortDirs: state.formCostColSortDirs,
						productProps: props.propsFromSaleSky.productProps,
						stateHandler: props.stateHandler,
						userId: props.userId,
						userName: props.userName,
						...commonProps
					};
					break;
				case 'form-margin':
					requiredProps = {
						formMarginSortedData: state.formMarginSortedData,
						formMarginColSortDirs: state.formMarginColSortDirs,
						productProps: props.propsFromSaleSky.productProps,
						stateHandler: props.stateHandler,
						userId: props.userId,
						userName: props.userName,
						...commonProps
					};
					break;
				case 'form-order':
					requiredProps = {
						formOrderSortedData: state.formOrderSortedData,
						formOrderColSortDirs: state.formOrderColSortDirs,
						productProps: props.propsFromSaleSky.productProps,
						stateHandler: props.stateHandler,
						userId: props.userId,
						userName: props.userName,
						...commonProps
					};
					break;
				case 'form-goods':
					requiredProps = {
						formGoodsSortedData: state.formGoodsSortedData,
						formGoodsColSortDirs: state.formGoodsColSortDirs,
						productProps: props.propsFromSaleSky.productProps,
						stateHandler: props.stateHandler,
						userId: props.userId,
						userName: props.userName,
						...commonProps
					};
					break;
				case 'form-lading':
					requiredProps = {
						formLadingSortedData: state.formLadingSortedData,
						formLadingColSortDirs: state.formLadingColSortDirs,
						productProps: props.propsFromSaleSky.productProps,
						stateHandler: props.stateHandler,
						userId: props.userId,
						userName: props.userName,
						...commonProps
					};
					break;
				case 'form-invoice':
					requiredProps = {
						formInvoiceSortedData: state.formInvoiceSortedData,
						formInvoiceColSortDirs: state.formInvoiceColSortDirs,
						productProps: props.propsFromSaleSky.productProps,
						stateHandler: props.stateHandler,
						userId: props.userId,
						userName: props.userName,
						...commonProps
					};
					break;
				case 'form-warehouse':
					requiredProps = {
						formWarehouseSortedData: state.formWarehouseSortedData,
						formWarehouseColSortDirs: state.formWarehouseColSortDirs,
						productProps: props.propsFromSaleSky.productProps,
						stateHandler: props.stateHandler,
						userId: props.userId,
						userName: props.userName,
						...commonProps
					};
					break;
				case 'new-admin':
					const adminItemRoute = getFuncTabRoute(props.pathname, adminRouteList);
					const stateNames = getAdminItemStateName(adminItemRoute) || {};
					// 汎用
					let byItemProps = {
						adminSortedData: state[stateNames.dataWrapperStateName],
						adminColSortDirs: state[stateNames.colSortDirsStateName],
						activeAdminItem: adminItemRoute,
					};

					// 額外
					switch (adminItemRoute) {
						case 'user-account':
							// 角色、群組資料 for 下拉選單
							byItemProps.userRoleSortedData = state.userRoleSortedData;
							byItemProps.userGroupSortedData = state.userGroupSortedData;
							break;
						case 'user-role':
							byItemProps.userGroupSortedData = state.userGroupSortedData;
							break;

						case 'repair-area':
						case 'repair-form-type':
						case 'repair-warranty-type':
						case 'repair-product-from':
						case 'repair-service-type':
						case 'repair-owner-judgement':
						case 'repair-currency':
						case 'repair-service-satisfaction':
						case 'repair-issue-type':
						case 'news-type':
							byItemProps.apiAdaptedData = state[stateNames.apiAdaptedDataStateName];
							break;
						case 'repair-status':
							byItemProps.apiAdaptedData = state[stateNames.apiAdaptedDataStateName];
							showAddTrigger = false;
							break;
						case 'user-group':
						case 'supervisor-evaluation':
						case 'system-parameter-setting':
						case 'company-introduction':
						case 'company-zone':
						case 'company-industry':
						case 'company-trade':
							// 無特殊需求
							break;
						case 'work-nature':
						case 'work-progress':
						case 'project-progress':
							byItemProps.stateHandler = props.stateHandler;

							switch (adminItemRoute) {
								case 'work-nature':
									byItemProps.optsWorkNature = props.workLogProps.optsWorkNature;
									break;
								case 'work-progress':
									byItemProps.optsProgressStatus = props.workLogProps.optsProgressStatus;
									break;
								case 'project-progress':
									byItemProps.optsProjectProgress = props.workLogProps.optsProjectProgress;
									break;
								default:

							}
							break;
						case 'media-cloud-file-attribute-value':
							byItemProps.mediaCloudFileAttributeSortedData = state.mediaCloudFileAttributeSortedData;
							break;
						case 'media-cloud-file-attribute':
							showAddTrigger = false;
							break;
						default:
							// for group 狀態下add button不可用===
							showAddTrigger = false;
							// ===
							byItemProps = {
								adminSortedData: emptyDataList.emptyDataListWrapper,
								adminColSortDirs: emptyDataList.colSortDirs,
								activeAdminItem: 'default',
							};
					};

					requiredProps = {
						onSearchTextClear: this.handlers.onSearchTextClear,
						...byItemProps,
						...commonProps
					};
					break;
				default:
					let shippingRecordsProps,
						customerExtraProps;

					switch (currentFuncTabRoute) {
						case 'customer':
							shippingRecordsProps = {
								shippingRecordsPermission: this.permissions.shippingRecords,
								parentStateHandler: this.parentStateHandler,
								shippingRecordsSortedData: state.shippingRecordsSortedData_cus,
								shippingRecordsColSortDirs: state.shippingRecordsColSortDirs_cus,
							};

							customerExtraProps = {
								contentTableSortedData: state.contentTableSortedData,
								contentTableColSortDirs: state.contentTableColSortDirs,
								onlineRepairPermission: this.permissions.onlineRepair
							};
							// 客戶資訊tab需要
							oldFuncExtraProps = {
								parentStateHandler: this.parentStateHandler,
								loginCompanyInfo: props.propsPackageFromSkyFamily,
								showBatchExportUI: state.showBatchExportUI,
								onBatchBtnClick: this.handlers.onBatchBtnClick,
								costViewPermission: props.userPermission.servicesky_cost_view
							};
							break;
						case 'online-repair-service':
							oldFuncExtraProps = {
								parentStateHandler: this.parentStateHandler,
								loginCompanyInfo: props.propsPackageFromSkyFamily,
								showBatchExportUI: state.showBatchExportUI,
								showCloudSearchForm: state.showCloudSearchForm,
								costViewPermission: props.userPermission.servicesky_cost_view
							};
							break;
						// case 'form-quotation':
						// 	oldFuncExtraProps = {
						// 		parentStateHandler: this.parentStateHandler,
						// 		loginCompanyInfo: props.propsPackageFromSkyFamily,
						// 		// showBatchExportUI: state.showBatchExportUI,
						// 		showCloudSearchForm: state.showCloudSearchForm,
						// 	};
						// 	break;

						default:
					}

					// 舊的就概括承受，後續非必要就不傳遞了
					requiredProps = {
						// oldFuncExtraProps,
						shippingRecordsProps,
						customerExtraProps,
						closeModal: this.handlers.closeModal,
						routeHandler: props.routeHandler,
						returnDataListToDashboardFunc: props.returnDataListToDashboardFunc,
						filteredDataList: props.filteredDataList,
						tableFrom: props.tableFrom,
						userId: props.userId,
						userName: props.userName,
						stateHandler: props.stateHandler,
						workLogProps: props.workLogProps,
						optsContactUpdater: props.optsContactUpdater,
						optsCompanyUpdater: props.optsCompanyUpdater,
						workLogDataRefresh: props.workLogDataRefresh,
						logDataProcesser: props.logDataProcesser,
						comWorkLogFilter: props.comWorkLogFilter,
						calendarProps: props.calendarProps,
						calendarHandlers: props.calendarHandlers,
						tableHeight: state.tableHeight,
						isBigSideBar: props.isBigSideBar,
						updateSearchResults: this.handlers.updateSearchResults,
						searchResults: state.searchResults,
						propsPackageFromSkyFamily: props.propsPackageFromSkyFamily,
						propsFromSaleSky: props.propsFromSaleSky,
						workLogPermission: this.permissions.workLog
					};
					break;
			}

			// 全部加入多國語系資料與權限資料
			requiredProps = {
				languageData,
				languageCode,
				userPermission: props.userPermission,
				systemEnvironment: props.systemEnvironment,
				oldFuncExtraProps,
				...requiredProps
			};

			contentTable = React.cloneElement(props.content, requiredProps);
		}

		let onAdminTab = false;

		switch (state.funcTabRoute) {
			case 'UserGroup':
			case 'Role':
			case 'Zone':
			case 'Industry':
			case 'Trade':
			case 'WorkNature':
			case 'ProgressStatus':
			case 'ProjectProgress':
			case 'NewsType':
			case 'FilePropertyValue':
			case 'FileProperty':
			case 'ManageAccount':
			case 'UserCompanyInfo':
				onAdminTab = true;
				break;
			default:
		}

		// 新增權限控制
		let canAdd;
		switch (currentFuncTabRoute) {
			case 'online-repair-service':
				canAdd =
					location.hostname === 'localhost' ||
					props.userPermission.salesky_repair_web * 1 > 1 ||
					props.userPermission.servicesky_repair_web * 1 > 1;
				break;
			case 'form-quotation':
				canAdd = props.userPermission.salesky_quotation_web * 1 > 1;
				break;

			default:
				canAdd = true;
				break;
		}

		return (
			<Tab.Container id='div-sidebar-container' defaultActiveKey='third'>
				<Row className='clearfix'>
					<Col className={(props.isBigSideBar ? '' : 'sidebar-small ') + 'sidebar-left-container'}>
						<Col className={(props.isBigSideBar ? '' : 'sidebar-small ') + 'sidebar-left'}>
							{
								this.permissions.news ?
									<Link
										id='link-news'
										to='/salesky/news'
										activeClassName={'active-link'}
										onClick={() => { this.setState({ ...this.handlers.onLinkClick('news') }); }}>

										<div></div>
										<span className={props.isBigSideBar ? '' : 'sidebar-small'}></span>
										{props.isBigSideBar ? languageData['42'][languageCode] : ''}
									</Link>
									:
									''
							}
							{
								false &&
									this.permissions.calendar ?
									<Link
										id='link-calendar'
										to='/salesky/calendar'
										activeClassName={'active-link'}
										onClick={() => { this.setState({ ...this.handlers.onLinkClick('calendar') }); }}>

										<div></div>
										<span className={props.isBigSideBar ? '' : 'sidebar-small'}></span>
										{props.isBigSideBar ? languageData['54'][languageCode] : ''}
									</Link>
									:
									''
							}
							{
								false &&
									this.permissions.workLog ?
									<Link
										id='link-work-log'
										to='/salesky/work-log'
										activeClassName={'active-link'}
										onClick={() => { this.setState({ ...this.handlers.onLinkClick('work-log') }); }}>

										<div></div>
										<span className={props.isBigSideBar ? '' : 'sidebar-small'}></span>
										{props.isBigSideBar ? languageData['80'][languageCode] : ''}
									</Link>
									:
									''
							}
							{
								false &&
									this.permissions.customer ?
									<Link
										id='link-customer'
										to='/salesky/customer'
										activeClassName={'active-link'}
										onClick={() => { this.setState({ ...this.handlers.onLinkClick('customer') }); }}>

										<div></div>
										<span className={props.isBigSideBar ? '' : 'sidebar-small'}></span>
										{props.isBigSideBar ? languageData['73'][languageCode] : ''}
									</Link>
									:
									''
							}
							{
								false &&
									this.permissions.saleCase ?
									<Link
										id='link-sales-cases'
										to='/salesky/sales-cases'
										activeClassName={'active-link'}
										onClick={() => { this.setState({ ...this.handlers.onLinkClick('sales-cases') }); }}>

										<div></div>
										<span className={props.isBigSideBar ? '' : 'sidebar-small'}></span>
										{props.isBigSideBar ? languageData['479'][languageCode] : ''}
									</Link>
									:
									''
							}
							{
								false &&
									this.permissions.shippingRecords ?
									<Link
										id='link-shipping-records'
										to='/salesky/shipping-records'
										activeClassName={'active-link'}
										onClick={() => { this.setState({ ...this.handlers.onLinkClick('shipping-records') }); }}>

										<div></div>
										<span className={props.isBigSideBar ? '' : 'sidebar-small'}></span>
										{props.isBigSideBar ? languageData['436'][languageCode] : ''}
									</Link>
									:
									''
							}
							{
								this.permissions.product ?
									<Link
										id='link-product'
										to='/salesky/product'
										activeClassName={'active-link'}
										onClick={() => { this.setState({ ...this.handlers.onLinkClick('product') }); }}>

										<div></div>
										<span className={props.isBigSideBar ? '' : 'sidebar-small'}></span>
										{props.isBigSideBar ? languageData['72'][languageCode] : ''}
									</Link>
									:
									''
							}
							{
								false &&
									this.permissions.km ?
									<Link
										id='link-km'
										to='/salesky/km'
										activeClassName={'active-link'}
										onClick={() => { this.setState({ ...this.handlers.onLinkClick('km') }); }}>

										<div></div>
										<span className={props.isBigSideBar ? '' : 'sidebar-small'}></span>
										{props.isBigSideBar ? languageData['270'][languageCode] : ''}
									</Link>
									:
									''
							}
							{
								this.permissions.onlineRepair ?
									<Link
										id='link-online-repair-service'
										to='/salesky/online-repair-service'
										activeClassName={'active-link'}
										onClick={() => { this.setState({ ...this.handlers.onLinkClick('online-repair-service') }); }}>

										<div></div>
										<span className={props.isBigSideBar ? '' : 'sidebar-small'}></span>
										{props.isBigSideBar ? languageData['5006'] ? languageData['5006'][languageCode] : languageData['448'][languageCode] : ''}
									</Link>
									:
									''
							}
							{
								false &&
									this.permissions.partsBase ?
									<Link
										id='link-parts-base'
										to='/salesky/parts-base'
										activeClassName={'active-link'}
										onClick={() => { this.setState({ ...this.handlers.onLinkClick('parts-base') }); }}>

										<div></div>
										<span className={props.isBigSideBar ? '' : 'sidebar-small'}></span>
										{props.isBigSideBar ? languageData['413'][languageCode] : ''}
									</Link>
									:
									''
							}
							{
								false &&
									this.permissions.mediaCloud ?
									<Link
										id='link-media-cloud'
										to='/salesky/media-cloud'
										activeClassName={'active-link'}
										onClick={() => { this.setState({ ...this.handlers.onLinkClick('media-cloud') }); }}>

										<div></div>
										<span className={props.isBigSideBar ? '' : 'sidebar-small'}></span>
										{props.isBigSideBar ? languageData['65'][languageCode] : ''}
									</Link>
									:
									''
							}
							{/* 以下客製化 */}
							{
								this.permissions.formQuotation ?
									<Link
										id='link-formQuotation'
										to='/salesky/form-quotation'
										activeClassName={'active-link'}
										onClick={() => { this.setState({ ...this.handlers.onLinkClick('form-quotation') }); }}>

										<div></div>
										<span className={props.isBigSideBar ? '' : 'sidebar-small'}></span>
										{props.isBigSideBar ? languageData['5007'] ? languageData['5007'][languageCode] : languageData['448'][languageCode] : ''}
									</Link>
									:
									''
							}
							{
								false &&
									this.permissions.formCost ?
									<Link
										id='link-formCost'
										to='/salesky/form-cost'
										activeClassName={'active-link'}
										onClick={() => { this.setState({ ...this.handlers.onLinkClick('form-cost') }); }}>

										<div></div>
										<span className={props.isBigSideBar ? '' : 'sidebar-small'}></span>
										{props.isBigSideBar ? languageData['5008'] ? languageData['5008'][languageCode] : languageData['448'][languageCode] : ''}
									</Link>
									:
									''
							}
							{
								false &&
									this.permissions.formMargin ?
									<Link
										id='link-formMargin'
										to='/salesky/form-margin'
										activeClassName={'active-link'}
										onClick={() => { this.setState({ ...this.handlers.onLinkClick('form-margin') }); }}>

										<div></div>
										<span className={props.isBigSideBar ? '' : 'sidebar-small'}></span>
										{props.isBigSideBar ? languageData['5009'] ? languageData['5009'][languageCode] : languageData['448'][languageCode] : ''}
									</Link>
									:
									''
							}
							{
								false &&
									this.permissions.formOrder ?
									<Link
										id='link-formOrder'
										to='/salesky/form-order'
										activeClassName={'active-link'}
										onClick={() => { this.setState({ ...this.handlers.onLinkClick('form-order') }); }}>

										<div></div>
										<span className={props.isBigSideBar ? '' : 'sidebar-small'}></span>
										{props.isBigSideBar ? languageData['5010'] ? languageData['5010'][languageCode] : languageData['448'][languageCode] : ''}

									</Link>
									:
									''
							}
							{
								false &&
									this.permissions.formGoods ?
									<Link
										id='link-formGoods'
										to='/salesky/form-goods'
										activeClassName={'active-link'}
										onClick={() => { this.setState({ ...this.handlers.onLinkClick('form-goods') }); }}>

										<div></div>
										<span className={props.isBigSideBar ? '' : 'sidebar-small'}></span>
										{props.isBigSideBar ? languageData['5011'] ? languageData['5011'][languageCode] : languageData['448'][languageCode] : ''}
									</Link>
									:
									''
							}
							{
								false &&
									this.permissions.formLading ?
									<Link
										id='link-formLading'
										to='/salesky/form-lading'
										activeClassName={'active-link'}
										onClick={() => { this.setState({ ...this.handlers.onLinkClick('form-lading') }); }}>

										<div></div>
										<span className={props.isBigSideBar ? '' : 'sidebar-small'}></span>
										{props.isBigSideBar ? languageData['5012'] ? languageData['5012'][languageCode] : languageData['448'][languageCode] : ''}
									</Link>
									:
									''
							}
							{
								false &&
									this.permissions.formInvoice ?
									<Link
										id='link-formInvoice'
										to='/salesky/form-invoice'
										activeClassName={'active-link'}
										onClick={() => { this.setState({ ...this.handlers.onLinkClick('form-invoice') }); }}>

										<div></div>
										<span className={props.isBigSideBar ? '' : 'sidebar-small'}></span>
										{props.isBigSideBar ? languageData['5013'] ? languageData['5013'][languageCode] : languageData['448'][languageCode] : ''}
									</Link>
									:
									''
							}
							{
								false &&
									this.permissions.formWarehouse ?
									<Link
										id='link-formWarehouse'
										to='/salesky/form-warehouse'
										activeClassName={'active-link'}
										onClick={() => { this.setState({ ...this.handlers.onLinkClick('form-warehouse') }); }}>

										<div></div>
										<span className={props.isBigSideBar ? '' : 'sidebar-small'}></span>
										{props.isBigSideBar ? languageData['5014'] ? languageData['5014'][languageCode] : languageData['448'][languageCode] : ''}
									</Link>
									:
									''
							}
							{/* 以上客製化 */}
							{
								this.permissions.report ?
									<Link
										id='link-report'
										to='/salesky/report'
										activeClassName={'active-link'}
										onClick={() => { this.setState({ ...this.handlers.onLinkClick('report') }); }}>

										<div></div>
										<span className={props.isBigSideBar ? '' : 'sidebar-small'}></span>
										{props.isBigSideBar ? languageData['75'][languageCode] : ''}
									</Link>
									:
									''
							}

							{
								props.propsPackageFromSkyFamily.isAdmin === '1' ?
									<Link
										id='link-new-admin'
										to='/salesky/new-admin'
										activeClassName={'active-link'}
										onClick={() => { this.setState({ ...this.handlers.onLinkClick('new-admin') }); }}>

										<div></div>
										<span className={props.isBigSideBar ? '' : 'sidebar-small'}></span>
										{props.isBigSideBar ? languageData['460'][languageCode] : ''}
									</Link>
									:
									''
							}

							{
								false &&
									props.propsPackageFromSkyFamily.isAdmin === '1' ?
									<Link
										id='link-admin/UserCompanyInfo'
										to='/salesky/admin/UserCompanyInfo'
										className={onAdminTab ? 'a-parent-link active-link' : 'a-parent-link'}
										onClick={() => { this.setState({ ...this.handlers.onLinkClick('UserCompanyInfo') }); }}>

										<div></div>
										<span className={props.isBigSideBar ? '' : 'sidebar-small'}></span>
										{props.isBigSideBar ? languageData['460'][languageCode] : ''}
										{props.isBigSideBar ? <span className='span-collapsing-arrow'></span> : ''}
									</Link>
									:
									''
							}

							{/* 子選單 */}

							<Link
								id='link-admin/UserCompanyInfo'
								to='/salesky/admin/UserCompanyInfo'
								activeClassName={'active-child-link'}
								className={onAdminTab ? 'a-child-link' : 'control-not-display a-child-link'}
								onClick={() => { this.setState({ ...this.handlers.onLinkClick('UserCompanyInfo') }); }}>

								<span className={props.isBigSideBar ? 'span-hier1-icon' : 'span-hier1-icon sidebar-small'}>‧</span>
								{props.isBigSideBar ? '公司簡介' : <Tooltip tipText='公司簡介' placement='right' />}

							</Link>

							<Link
								id='link-admin/Role'
								to='/salesky/admin/Role'
								activeClassName={'active-child-link'}
								className={onAdminTab ? 'a-child-link' : 'control-not-display a-child-link'}
								onClick={() => { this.setState({ ...this.handlers.onLinkClick('Role') }); }}>

								<span className={props.isBigSideBar ? 'span-hier1-icon' : 'span-hier1-icon sidebar-small'}>‧</span>
								{props.isBigSideBar ? '角色' : <Tooltip tipText='角色' placement='right' />}
							</Link>

							<Link
								id='link-admin/Zone'
								to='/salesky/admin/Zone'
								activeClassName={'active-child-link'}
								className={onAdminTab ? 'a-child-link' : 'control-not-display a-child-link'}
								onClick={() => { this.setState({ ...this.handlers.onLinkClick('Zone') }); }}>

								<span className={props.isBigSideBar ? 'span-hier1-icon' : 'span-hier1-icon sidebar-small'}>‧</span>
								{props.isBigSideBar ? '地區' : <Tooltip tipText='地區' placement='right' />}
							</Link>

							<Link
								id='link-admin/Industry'
								to='/salesky/admin/Industry'
								activeClassName={'active-child-link'}
								className={onAdminTab ? 'a-child-link' : 'control-not-display a-child-link'}
								onClick={() => { this.setState({ ...this.handlers.onLinkClick('Industry') }); }}>

								<span className={props.isBigSideBar ? 'span-hier1-icon' : 'span-hier1-icon sidebar-small'}>‧</span>
								{props.isBigSideBar ? '行業別' : <Tooltip tipText='行業別' placement='right' />}
							</Link>

							<Link
								id='link-admin/Trade'
								to='/salesky/admin/Trade'
								activeClassName={'active-child-link'}
								className={onAdminTab ? 'a-child-link' : 'control-not-display a-child-link'}
								onClick={() => { this.setState({ ...this.handlers.onLinkClick('Trade') }); }}>

								<span className={props.isBigSideBar ? 'span-hier1-icon' : 'span-hier1-icon sidebar-small'}>‧</span>
								{props.isBigSideBar ? '產業' : <Tooltip tipText='產業' placement='right' />}
							</Link>

							<Link
								id='link-admin/WorkNature'
								to='/salesky/admin/WorkNature'
								activeClassName={'active-child-link'}
								className={onAdminTab ? 'a-child-link' : 'control-not-display a-child-link'}
								onClick={() => { this.setState({ ...this.handlers.onLinkClick('WorkNature') }); }}>

								<span className={props.isBigSideBar ? 'span-hier1-icon' : 'span-hier1-icon sidebar-small'}>‧</span>
								{props.isBigSideBar ? '工作性質' : <Tooltip tipText='工作性質' placement='right' />}
							</Link>

							<Link
								id='link-admin/ProgressStatus'
								to='/salesky/admin/ProgressStatus'
								activeClassName={'active-child-link'}
								className={onAdminTab ? 'a-child-link' : 'control-not-display a-child-link'}
								onClick={() => { this.setState({ ...this.handlers.onLinkClick('ProgressStatus') }); }}>

								<span className={props.isBigSideBar ? 'span-hier1-icon' : 'span-hier1-icon sidebar-small'}>‧</span>
								{props.isBigSideBar ? '工作進度' : <Tooltip tipText='工作進度' placement='right' />}
							</Link>

							<Link
								id='link-admin/ProjectProgress'
								to='/salesky/admin/ProjectProgress'
								activeClassName={'active-child-link'}
								className={onAdminTab ? 'a-child-link' : 'control-not-display a-child-link'}
								onClick={() => { this.setState({ ...this.handlers.onLinkClick('ProjectProgress') }); }}>

								<span className={props.isBigSideBar ? 'span-hier1-icon' : 'span-hier1-icon sidebar-small'}>‧</span>
								{props.isBigSideBar ? '專案狀態' : <Tooltip tipText='專案狀態' placement='right' />}
							</Link>

							<Link
								id='link-admin/NewsType'
								to='/salesky/admin/NewsType'
								activeClassName={'active-child-link'}
								className={onAdminTab ? 'a-child-link' : 'control-not-display a-child-link'}
								onClick={() => { this.setState({ ...this.handlers.onLinkClick('NewsType') }); }}>

								<span className={props.isBigSideBar ? 'span-hier1-icon' : 'span-hier1-icon sidebar-small'}>‧</span>
								{props.isBigSideBar ? '新聞分類' : <Tooltip tipText='新聞分類' placement='right' />}
							</Link>

							<Link
								id='link-admin/FilePropertyValue'
								to='/salesky/admin/FilePropertyValue'
								activeClassName={'active-child-link'}
								className={onAdminTab ? 'a-child-link' : 'control-not-display a-child-link'}
								onClick={() => { this.setState({ ...this.handlers.onLinkClick('FilePropertyValue') }); }}>

								<span className={props.isBigSideBar ? 'span-hier1-icon' : 'span-hier1-icon sidebar-small'}>‧</span>
								{props.isBigSideBar ? '檔案屬性值' : <Tooltip tipText='檔案屬性值' placement='right' />}
							</Link>

							<Link
								id='link-admin/FileProperty'
								to='/salesky/admin/FileProperty'
								activeClassName={'active-child-link'}
								className={onAdminTab ? 'a-child-link' : 'control-not-display a-child-link'}
								onClick={() => { this.setState({ ...this.handlers.onLinkClick('FileProperty') }); }}>

								<span className={props.isBigSideBar ? 'span-hier1-icon' : 'span-hier1-icon sidebar-small'}>‧</span>
								{props.isBigSideBar ? '檔案屬性' : <Tooltip tipText='檔案屬性' placement='right' />}
							</Link>

							<Link
								id='link-admin/ManageAccount'
								to='/salesky/admin/ManageAccount'
								activeClassName={'active-child-link'}
								className={onAdminTab ? 'a-child-link' : 'control-not-display a-child-link'}
								onClick={() => { this.setState({ ...this.handlers.onLinkClick('ManageAccount') }); }}>

								<span className={props.isBigSideBar ? 'span-hier1-icon' : 'span-hier1-icon sidebar-small'}>‧</span>
								{props.isBigSideBar ? '帳戶管理' : <Tooltip tipText='帳戶管理' placement='right' />}
							</Link>

							<Link
								id='link-admin/UserGroup'
								to='/salesky/admin/UserGroup'
								activeClassName={'active-child-link'}
								className={onAdminTab ? 'a-child-link' : 'control-not-display a-child-link'}
								onClick={() => { this.setState({ ...this.handlers.onLinkClick('UserGroup') }); }}>

								<span className={props.isBigSideBar ? 'span-hier1-icon' : 'span-hier1-icon sidebar-small'}>‧</span>
								{props.isBigSideBar ? '使用者群組' : <Tooltip tipText='使用者群組' placement='right' />}
							</Link>

						</Col>
					</Col>
					<Col className={(props.isBigSideBar ? '' : 'sidebar-small ') + 'sidebar-right'} style={{ overflow: 'auto' }}>
						<Tab.Content /* animation 只用一個tab，此屬性無用 */>
							<Tab.Pane eventKey='third'>
								<div id='div-sidebar-right-header' className='clearfix'>
									{state.onTabName}

									{/* 新增 */}
									<AddTrigger disabled={!canAdd} className={showAddTrigger ? '' : 'addtrigger-disable '}
										onClick={this.handlers.clickAdd} />
									{/* 雲端搜尋 */}
									{
										showCloudSearchIcon ?
											<Tooltip
												tipText={'雲端搜尋'}
												child={
													<span
														className={this.state.showCloudSearchForm ? 'span-cloud-search-icon-active' : 'span-cloud-search-icon'}
														onClick={this.handlers.onCloudSearchToggle}
														style={{ left: showAddTrigger ? 40 : 0 }}>
													</span>
												}
											/>
											: ''
									}
									{/* 本地搜尋 */}
									{
										showLocalSearchIcon ?
											<Tooltip
												tipText={'本地搜尋'}
												child={
													<span
														className='span-local-search-icon'
														onClick={this.handlers.onLocalSearchToggle}
														style={{
															left: !showAddTrigger ? 0 : showCloudSearchIcon ? 80 : 40,
															display: this.state.showLocalSearchForm ? 'none' : ''
														}}>
													</span>
												}
											/>
											: ''
									}
									{
										(
											showLocalSearchIcon &&
											this.state.showLocalSearchForm
										) ?
											<FormGroup
												id='div-search-form-group'
												style={{
													left: !showAddTrigger ? 0 : showCloudSearchIcon ? 80 : 40,
													display: this.state.showLocalSearchForm ? '' : 'none'
												}}>

												<FormControl.Feedback>
													<Glyphicon glyph='search' style={{ left: 0 }} />
												</FormControl.Feedback>
												<FormControl
													type='text'
													placeholder='Search'
													value={state.searchTextInputValue}
													onChange={this.handlers.onSearchChange} />
												<FormControl.Feedback>
													<Glyphicon glyph='remove' className='removeBtn' onClick={this.handlers.onSearchTextClear} />
												</FormControl.Feedback>
											</FormGroup>
											: ''
									}

									{/* 批次上傳介面觸發按鈕 */}
									{/* {
                    showBatchUploadTrigger ? 
                      <BatchUITrigger tipText='批次上傳。' onClick={this.handlers.onBatchBtnClick('showBatchUploadModal')} />
                    :
                      null
                  } */}

									{/* 批次匯出pdf介面觸發按鈕 */}
									{
										showBatchExportTrigger && false ?
											<BatchUITrigger className='span-batch-download-icon' tipText='批次匯出PDF。' onClick={this.handlers.onBatchBtnClick('showBatchExportUI')} />
											:
											null
									}

								</div>

								{contentTable}
							</Tab.Pane>
						</Tab.Content>
					</Col>
					{
						state.showBatchUploadModal ?
							<BatchUploadModalCt
								parentStateHandler={this.parentStateHandler} />
							: ''
					}
				</Row>
			</Tab.Container>
		);
	}
};


// WEBPACK FOOTER //
// ./src/salesky/routes/dashboard/SideBarGroupCt.jsx